export default __webpack_public_path__ + "static/media/card11.7afbfcd0.png";